import React from 'react'

const TableHeader = () => {
  return (
    <div className="row p-0 m-0 mb-1 border_2_2px_top border_2_1px_bottom  heading_dyn_creation_data">
      <div
        className="col-4 p-0 m-0 ps-2 font_size font-weight-bold"
        style={{ textAlign: "left" }}
      >
        Particulars
      </div>
      <div
        className="col-6 p-0 m-0 font_size font-weight-bold"
        style={{ textAlign: "left" }}
      ></div>
      <div
        className="col-2 p-0 m-0 pe-1 font_size font-weight-bold "
        style={{ textAlign: "right" }}
      >
        Amount
      </div>
    </div>
  )
}

export default TableHeader
